/**
 * --bq-sb-right: scrollbar width inside the containing block of fixed elements
 * (.page-wrapper from 990px, else 0). Loaded synchronously: the Nuwa and
 * back-to-top launchers offset by it and jump if it is unset at first paint.
 */
(function () {
  var pw = document.querySelector('.page-wrapper');
  var sq = window.matchMedia('(min-width: 990px)');
  function set() {
    var sb = (pw && sq.matches) ? (pw.offsetWidth - pw.clientWidth) : 0;
    document.documentElement.style.setProperty('--bq-sb-right', sb + 'px');
  }
  set();
  window.addEventListener('resize', set, { passive: true });
  sq.addEventListener('change', set);
})();
